import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState, useContext } from "react";
import {
  Typography,
  Box,
  createTheme,
  ThemeProvider,
  Card,
  CardHeader,
  Stack,
  Tooltip,
} from "@mui/material";
//import Button from "../../../toolkit/Button";
import Label from "../../../toolkit/Label";
import IconButton from "@mui/material/IconButton";
import baseTheme from "../../../themes/baseTheme";
import trash1 from "../../../icons/trash1.svg";
import edit from "../../../icons/edit.svg";
import Avatar from "../../../icons/Avatar.svg";
import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "../../../utils/fvAxios";
import BaseURL from "../../../utils/base-uri.json";
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";
import { styled } from "@mui/material";

const { palette } = baseTheme;
const theme = createTheme({});
const padding = "16px 24px";

export default function CompanyListItem({
  status,
  headers = [],
  statusRoleMap,
  ...props
}) {


  status = statusRoleMap[status];
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [organization, setOrganization] = React.useState("");
  const OrganizationChange = (event) => {
    setOrganization(event.target.value);
  };
  const [userRoles, setUserRoles] = React.useState("");
  const handleChange = (event) => {
    setUserRoles(event.target.value);
  };
  const confirmDelete = async () => {
    setIsDeleting(true);
    const resp = await axios.post(
      BaseURL.settings.DeleteUser + "?userId=" + props.userId,
      {}
    );
    if (resp.data?.responseMessage === "Success") {
      setDeleteDialogOpen(false);
      setIsDeleting(false);
      // deleteUser();
      // setRefreshUserlist((prev) => !prev);
    } else {
      console.error(resp?.data?.responseMessage);
    }
  };
  const handleDialogClose = () => {
    setDeleteDialogOpen(false);
  };
  const handleclick = (e) => {
    if (e.organizationType == "Vendor") {
      {
        !HasScreenPermissions(INFO?.EditVendor?.actionName) &&
          navigate(
            "/EditVendor?vendorid=" + e.organizationID
          )
      }
    } else if (e.organizationType == "Client" || e.organizationType == "Super Client" || e.organizationType == "Admin") {
      {
        !HasScreenPermissions(INFO?.EditClient?.actionName) &&
          navigate(
            "/EditClient?OrgId=" + e.organizationID
          )
      }
    }
  };
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background:  rgba(97, 97, 97, 0.92)!important;
      color:#fff !important
    }
       & .MuiTooltip-arrow: {
      color: rgba(97, 97, 97, 0.92)!important;
    }
  `;
  return (
    <>
      <ThemeProvider theme={theme}>
        <Box
          display="flex"
          padding={padding}
          borderBottom="solid 1px"
          borderColor={palette.grey[30]}
          alignItems="center"
        >
          <Box width={headers.find((h) => h.id === "CompanyName")}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                "& svg": { m: 1.5 },
                "& hr": { mx: 0.5 },
              }}
            >
              <img
                style={{ marginRight: "10px" }}
                src={Avatar}
                alt="avataricon"
              />
              <div>
                <Typography
                  variant="body2"
                  style={{ textDecoration: "none", color: "#101828" }}
                // to={"/userdetails?u=" + props.userId}
                >
                  <h6>{props.name}</h6>
                </Typography>
              </div>
            </Box>

            <Typography></Typography>
            <Box sx={{ color: palette.grey[80] }}> </Box>
          </Box>
          <Box width={headers.find((h) => h.id === "Role")}>
            <Box sx={{ minWidth: "20%" }}>
              <Stack direction="row" spacing={2}>
                <Card
                  sx={{
                    width: "22px",
                    textAlign: "center",
                    backgroundColor: "#667085",
                    marginRight: "5px",
                    color: "#fff",
                    padding: "2px"
                  }}
                >
                  {props.organizationType && props.organizationType.length > 0 ? props.organizationType.charAt(0) : ''}
                </Card>
                <span style={{ color: "#667085", marginLeft: "3px" }}>
                  {" "}
                  {props.organizationType}
                </span>
              </Stack>
            </Box>
          </Box>


          <Box width={headers.find((h) => h.id === "icons")}>
            <Typography>
              <Tooltip title={HasScreenPermissions(INFO?.EditClient?.actionName && INFO?.EditVendor?.actionName) ? "YOU DONT HAVE A PERMISSIONS TO ACCESS THIS PAGE" : ""}>
                <IconButton
                  aria-label="edit"
                  //onClick={() => navigate("/userdetails?u=" + props.userId)}
                  onClick={() => handleclick(props)}
                  sx={{ float: "right" }}
                >
                  <img src={edit} alt="edit icon" />
                </IconButton>
              </Tooltip>
              <Dialog open={deleteDialogOpen} onClose={handleDialogClose}>
                <DialogTitle id="alert-dialog-title">
                  {"Are you sure you want to delete?"}
                </DialogTitle>
                <DialogActions className="w-100 d-flex">
                  <Button
                    variant="outlined"
                    onClick={handleDialogClose}
                    style={{ padding: "12px" }}
                  >
                    Cancel
                  </Button>
                  {isDeleting ? (
                    <Box
                      style={{
                        display: "flex",
                        marginLeft: "auto",
                        padding: "5px",
                      }}
                    >
                      <CircularProgress size={28} />
                    </Box>
                  ) : (
                    <Button
                      variant="contained"
                      onClick={confirmDelete}
                      style={{ marginLeft: "auto", padding: "12px" }}
                    >
                      Yes, delete
                    </Button>
                  )}
                </DialogActions>
              </Dialog>

            </Typography>
          </Box>
          {/* <Box width={headers.find((h) => h.id === "icon")}>
            <Typography>
              <IconButton
                aria-label="delete"
              
                
              >
              
              </IconButton>
            </Typography>

          </Box> */}
          {/* // onClick={() => { */}
          {/* //   setDeleteDialogOpen(true);
                //   setIsDeleting(false);
                // }} */}
          {/* <img src={trash1} alt="delete icon" /> */}
        </Box>
      </ThemeProvider>
    </>
  );
}
